import type { NotificationEntity } from '../../domain/entities/NotificationEntity.js';
import type {
  INotificationRepository,
  NotificationListOptions,
  NotificationSearchOptions,
} from '../../domain/repositories/INotificationRepository.js';
import type { NotificationRemoteDataSource } from '../datasources/NotificationRemoteDataSource.js';
import type { NotificationDto } from '../dtos/NotificationDto.js';

function mapDtoToEntity(dto: NotificationDto): NotificationEntity {
  return {
    id: dto.id,
    orgId: dto.org_id,
    projectId: dto.project_id ?? null,
    userId: dto.user_id,
    title: dto.title,
    body: dto.body,
    type: dto.type,
    resource: dto.resource,
    resourceId: dto.resource_id,
    metadata: dto.metadata ?? null,
    isRead: dto.is_read,
    createdAt: dto.created_at,
  };
}

export class NotificationRepository implements INotificationRepository {
  constructor(private readonly remoteDataSource: NotificationRemoteDataSource) {}

  async list(options: NotificationListOptions): Promise<NotificationEntity[]> {
    const rows = await this.remoteDataSource.list(options);
    return rows.map(mapDtoToEntity);
  }

  async search(options: NotificationSearchOptions): Promise<NotificationEntity[]> {
    const rows = await this.remoteDataSource.search(options);
    return rows.map(mapDtoToEntity);
  }

  unreadCount(projectId?: string): Promise<number> {
    return this.remoteDataSource.unreadCount(projectId);
  }

  markRead(id: string): Promise<void> {
    return this.remoteDataSource.markRead(id);
  }

  markAllRead(projectId?: string): Promise<void> {
    return this.remoteDataSource.markAllRead(projectId);
  }

  deleteRead(): Promise<void> {
    return this.remoteDataSource.deleteRead();
  }

  subscribe(userId: string, onChange: () => void): () => void {
    return this.remoteDataSource.subscribe(userId, onChange);
  }
}
